// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import App from './App'
import router from './router'
import store from './store/index'
import { sync } from 'vuex-router-sync'
import storage from './utils/storage'


import axios from 'axios';
import VueSimpleAlert from "vue-simple-alert";
Vue.use(VueSimpleAlert);

sync(store, router)
Vue.prototype.$_axios = axios;
Vue.prototype.$_storage = storage;
Vue.config.productionTip = false

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})





// WEBPACK FOOTER //
// ./src/main.js